import React from 'react';
import { connect } from 'react-redux'
import { FormattedMessage } from 'react-intl';
import FormCartToPrintShop from './forms/FormCartToPrintShop.react';

class CartPrintShopList extends React.Component {

    constructor(props, context) {
        super(props, context);
    }

    render() {

        const { items, deleteCartItem } = this.props;
        const link_price_list = <a href="/files/misc/20190709_Preisliste_Paulaner_Esta_Druck_GmbH.pdf" target="_blank" download><FormattedMessage id="LABEL_PRICE_LIST" /></a>;

        if (items.length === 0) {
            return <p><FormattedMessage id="TEXT_CART_EMPTY" /></p>;
        } else {
            return (
                <div className="panel-body">
                    <p><FormattedMessage id="TEXT_CART_INTRO_SHOP_PRINT" values={{link_price_list: link_price_list}}/></p>
                    <FormCartToPrintShop items={items} deleteCartItem={deleteCartItem} />
                </div>
            );
        }
    }
}

export default connect()(CartPrintShopList);



// WEBPACK FOOTER //
// ./src/js/components/CartPrintShopList.react.jsx